import { useState } from "react"
import { Modal } from "components"
import Label from "components/forms/label"
import InputDate from "components/forms/input-date"
import moment from "moment"
import { lang } from "config"
import useBranches from "repositories/branch"

const Content = ({ data, errors, onSubmit, onRemove }) => {
    const [branchId, setBranchId] = useState(data.branch_id || "")
    const [isActive, setIsActive] = useState(data.is_active || "")
    const [from, setFrom] = useState(data.from || "")
    const [to, setTo] = useState(data.to || "")

    const { data: branches, isLoading: branchesLoading } = useBranches({
        paginate: false
    })

    const handleSubmit = (e) => {
        e.preventDefault()

        const payload = {
            branch_id: branchId,
            is_active: isActive,
            from,
            to,
        }

        onSubmit(
            Object.fromEntries(
                Object.entries(payload).filter(([_, v]) => v != null && v !== "")
            )
        )
    }

    return (
        <form onSubmit={handleSubmit} className="mt-8 space-y-8">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div>
                    <Label htmlFor="branch_id" value={lang.branch} />
                    <select
                        id="branch_id"
                        value={branchId}
                        onChange={(e) => setBranchId(e.target.value)}
                        className="w-full px-4 py-3 text-xs transition border border-neutral-200 rounded-xl focus:outline-none focus:border-neutral-400 focus:ring focus:ring-neutral-200"
                    >
                        <option value="">
                            {branchesLoading ? "Loading branches..." : `All ${lang.branch}`}
                        </option>

                        {(branches ?? []).map((branch) => (
                            <option key={branch.id} value={branch.id}>
                                {branch.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div>
                    <Label htmlFor="is_active" value="Status" />
                    <select
                        id="is_active"
                        value={isActive}
                        onChange={(e) => setIsActive(e.target.value)}
                        className="w-full px-4 py-3 text-xs transition border border-neutral-200 rounded-xl focus:outline-none focus:border-neutral-400 focus:ring focus:ring-neutral-200"
                    >
                        <option value="">All</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                    </select>
                </div>

                <div>
                    <Label htmlFor="from" value={lang.from} />
                    <InputDate
                        id="from"
                        maxDate={to ? Date.parse(to) : null}
                        onChange={(value) => setFrom(moment(value).format("Y-M-DD"))}
                        value={from ? Date.parse(from) : null}
                        selected={from ? Date.parse(from) : null}
                    />
                </div>

                <div>
                    <Label htmlFor="to" value={lang.to} />
                    <InputDate
                        id="to"
                        minDate={from ? Date.parse(from) : null}
                        onChange={(value) => setTo(moment(value).format("Y-M-DD"))}
                        value={to ? Date.parse(to) : null}
                        selected={to ? Date.parse(to) : null}
                    />
                </div>
            </div>

            <div className="flex items-center space-x-2 text-xs">
                <button
                    type="submit"
                    className="items-center px-6 py-3 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90"
                >
                    <span>{lang.filter}</span>
                </button>

                <button
                    type="button"
                    onClick={onRemove}
                    className="items-center px-6 py-3 transition border border-neutral-200 bg-neutral-50 rounded-xl active:hover:scale-90"
                >
                    <span>{lang.clear}</span>
                </button>
            </div>
        </form>
    )
}

const Filter = ({ data, errors, onSubmit, onRemove }) => {
    const [isOpen, setIsOpen] = useState(false)

    const openModal = () => setIsOpen(true)
    const closeModal = () => setIsOpen(false)

    const handleSubmit = (value) => {
        closeModal()
        onSubmit(value)
    }

    const handleRemove = () => {
        closeModal()
        onRemove()
    }

    return (
        <>
            <button
                onClick={openModal}
                className="inline-flex items-center px-4 py-3 space-x-2 transition border border-neutral-200 bg-neutral-50 rounded-xl active:hover:scale-90"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    strokeWidth={1}
                    stroke="currentColor"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M5.5 5h13a1 1 0 0 1 .5 1.5l-5 5.5l0 7l-4 -3l0 -4l-5 -5.5a1 1 0 0 1 .5 -1.5"></path>
                </svg>

                <span>{lang.filter}</span>

                {Object.keys(data).length > 0 && (
                    <span className="inline-flex w-4 h-4 font-semibold rounded-full text-[0.5rem] justify-center text-neutral-200 bg-neutral-800">
                        {`${Object.keys(data).length}`}
                    </span>
                )}
            </button>

            <Modal
                isOpen={isOpen}
                onClose={closeModal}
                title={`${lang.filter} Cashier`}
                content={
                    <Content
                        errors={errors}
                        onSubmit={handleSubmit}
                        onRemove={handleRemove}
                        data={data}
                    />
                }
            />
        </>
    )
}

export default Filter